import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { useAppSelector } from '../../../store/reduxHooks';
import {
  useGetAllQuery,
  useTestContactUsMutation,
} from '../../../services/rtkQueryServices';
import { Button, Fab, Grid } from '@mui/material';
import { ContactUsReadOnly, NotificationsAdd } from './ContentForm';
import NavigationIcon from '@mui/icons-material/Navigation';

export default function NotificationsPage({}: any) {
  const user = useAppSelector((state) => state.auth.user);
  const [contactUsDemoApi, { isLoading, isSuccess }] =
    useTestContactUsMutation();

  const { data, isLoading: contactDataLoading } = useGetAllQuery({
    resource: 'contact-us',
    page: 0,
    search: '',
    pageSize: 1000,
  });
  useGetAllQuery;
  return (
    <>
      {data && data.result && data.result.length === 0 && (
        <Fab
          variant='extended'
          size='medium'
          color='primary'
          aria-label='add'
          disabled={isLoading}
          sx={{ position: 'absolute', bottom: '50px', right: '50px' }}
          onClick={() =>
            contactUsDemoApi({
              body: {
                name: user.displayName,
                email: 'test@gmail.com',
                message:
                  'Testing simple contact us message sent from admin panel ' +
                  new Date().toISOString(),
              },
            })
          }
        >
          <NavigationIcon sx={{ mr: 1 }} />
          Send Demo
        </Fab>
      )}
      <GenericCrudPage
        key='contact-us-page'
        tableColumns={[
          {
            field: 'title',
            headerName: 'Title',
            width: 200,
          },
          {
            field: 'message',
            headerName: 'Message',
            width: 200,
          },
        ]}
        singularName='message'
        pageTitle='Notifications'
        resource='notifications'
        allowAdd={true}
        allowEdit={false}
        allowDelete={true}
        ReadOnlyComponent={ContactUsReadOnly}
        EditFormComponent={NotificationsAdd}
        newPayload={{
          title: '',
          message: '',
        }}
        validateFn={(data: any) => {
          return [true, []];
        }}
      />
    </>
  );
}
